<template>
  <div class="main">
    <FormWrapper :action="route('profile.settings.update')" method="POST">
      <div class="title-bar">
        <h1>Settings</h1>
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters">
            <div class="col-12 mb-5 px-3 px-xxl-5">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
              <template
                v-if="!!emailSettings && Object.keys(emailSettings).length > 0"
              >
                <h4 class="text-uppercase">Email Notifications</h4>
                <p>
                  Use the checkboxes provided to enable or disable receipt of
                  the specified email notifications. Please note that some
                  notifications are critical and cannot be disabled.
                </p>
                <Field
                  v-for="(attrs, slug) in emailSettings"
                  :key="slug"
                  type="checkbox"
                  :name="`enable-email-${slug}`"
                  :id="`enable-email-${slug}`"
                  :label="attrs.label"
                  :disabled="attrs.disabled"
                  :value="!!meta[`enable-email-${slug}`] || attrs.disabled"
                  :checkbox-value="1"
                  class="mb-3"
                />
              </template>
              <template v-if="$root.isTrainer">
                <hr />
                <div class="row no-gutters">
                  <div class="col-12 col-xl-6">
                    <Field
                      type="text"
                      name="settings[survey-recipient-email]"
                      :value="meta['survey-recipient-email'] || ''"
                      label="Additional Survey Results Recipient (optional)"
                      help-text="Enter the email address of another, optional recipient who should be emailed the results of a survey for an event you are assigned to train."
                    />
                  </div>
                </div>
              </template>
              <template v-if="$root.isManager">
                <hr />
                <h4 class="text-uppercase">FAD/Elite Compliance Report</h4>
                <p>
                  Use the drop down menu provided to opt-in to receiving a
                  regularly scheduled Compliance Report for your distribution.
                  This report will be for the current year. During the month of
                  January you will also receive the previous year.
                </p>
                <div class="row no-gutters">
                  <div class="col-12 col-xl-6">
                    <Field
                      type="select"
                      name="settings[company-hour-report-optin]"
                      :value="meta['company-hour-report-optin'] || null"
                      :options="companyHourReportOptions"
                    />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="text-center">
              <button type="submit" class="btn btn-success mr-2 mb-3">
                Save Changes
              </button>
              <a class="btn btn-info mb-3" href="?discard=true"
                >Discard Changes</a
              >
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    meta: { type: Object, default: () => {} },
    emailSettings: { type: Object, required: true },
  },
  data() {
    return {
      companyHourReportOptions: [
        {
          label: "I would NOT like to receive a report",
          value: "",
        },
        {
          label: "I would like a DAILY report",
          value: "daily",
        },
        {
          label: "I would like a WEEKLY report (delivered on Monday)",
          value: "weekly",
        },
        {
          label:
            "I would like a MONTHLY report (delivered on the 1st of the month)",
          value: "monthly",
        },
      ],
    };
  },
};
</script>